import * as Yup from "yup";

export const ContractorProjectFormSchema = Yup.object().shape({
  projectId: Yup.string().required("Project ID is required"),
  jobSite: Yup.string().required("Job site is required"),
});
